import Navbar from "../components/NavBar";
// import SportsBanner from "../components/SportsBanner";
import SportsContent from "../components/SportsContent";
import Footer from "../components/Footer";


const Sports = () => {


  return (
    <div className="">
      <Navbar />
        {/* <SportsBanner /> */}
        <div className="App-header">
          <div className="container-md">
            <SportsContent />
          </div>
        </div>
      <Footer />
    </div>
  );
};

export default Sports;